import { FC, useCallback } from 'react';

import { useMapContext } from 'shared/context/MapContext';

import { ZoomIn } from './ZoomIn';

export const ZoomInContainer: FC = () => {
  const { map } = useMapContext();

  const handleClick = useCallback(() => {
    const zoom = map.getZoom();
    const [, maxZoom] = map.zoomRange.getCurrent();

    if (zoom >= maxZoom) {
      return;
    }

    map.setZoom(zoom + 1);
  }, [map]);

  return <ZoomIn handleClick={handleClick} />;
};
